
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24.041","height":"24.041","viewBox":"0 0 6.361 6.361","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.748.003L0 .75 2.43 3.183 0 5.615l.748.749L3.18 3.932l2.432 2.432.748-.749-2.432-2.432L6.36.751 5.612.003 3.18 2.435z","stroke-miterlimit":"4.3","stroke-width":"4.351"}})])
          )
        }
      }
    